import type { OutreachRow } from '@discovr/types';
import { isBrandLive, isInOutreach } from './handoffStates';
import type { ComposerKind } from './ThreadComposer';

type KindRow = Pick<OutreachRow, 'status' | 'outreachState' | 'brandState' | 'confirmedAt' | 'brandDecidedAt' | 'lastMessage'>;

/** A counter's amounts: kept for the read-only counter line and a saved draft. V2: negotiation history sends them too; V1 sends a plain reply. */
export const needsRates = (kind: ComposerKind): boolean => kind === 'counter';

/** A counter answers a price the creator mailed (R12-11): with no mailed quote there is no Counter, whatever else is true of the row. It is open on a pre-agree thread, or once the brand asked for less (D5). From the brand's approval on it is closed (G8-13): a changed price goes through Agree rate. */
export function canCounter(row: KindRow, hasQuote: boolean): boolean {
  if (!hasQuote) return false;
  const preAgree = isInOutreach(row) && (row.outreachState === 'contacted' || row.outreachState === 'replied');
  return preAgree || (isBrandLive(row.status) && row.status !== 'accepted_by_brand' && row.brandState === 'counter_requested');
}

/** The row's own quote fact when Go sends it; an older Go falls back to the quote the thread shows. */
export const hasMailedQuote = (row: Pick<OutreachRow, 'hasQuote'>, threadQuote: unknown): boolean => row.hasQuote ?? !!threadQuote;
